import dynamic from 'next/dynamic';

export interface IFullscreenCamProps {
  /** Full-size cam frame. */
  image: string;
  /** Accessible name for the photo — the cam location, and the resort when known. */
  alt: string;
  /** Caption shown over the bottom of the photo (cam name + timestamp). Omit to hide. */
  title?: string;
  onClose: () => void;
}

// Split out of the page bundle: the viewer only exists after a tap, and it
// pulls in the fullscreen/orientation plumbing with it.
const DynamicComponent = dynamic(() => import('./FullscreenCam'), { loading: () => null });

export const FullscreenCam = (props: IFullscreenCamProps) => (
  <DynamicComponent {...props} />
);
